/**
 * El chat de un teléfono en el Simulador del ambiente de prueba. PURO.
 *
 * Lo escrito COMO ese teléfono (mensajes del cliente) y lo que el sistema le
 * "mandó" (la bandeja de envíos simulados) vienen de lugares distintos; la
 * pantalla los muestra como un solo chat, en orden de tiempo.
 */

/** Un mensaje que se escribió como ese teléfono. */
export interface EscritoPorTelefono {
  id: string;
  texto: string;
  fecha: string;
}

/** Un envío que el candado retuvo y le habría llegado a ese teléfono. */
export interface RecibidoPorTelefono {
  id: string;
  contenido: string;
  tipo: 'texto' | 'medio' | string;
  createdAt: string;
}

export interface BurbujaChat {
  id: string;
  lado: 'escrito' | 'recibido';
  texto: string;
  fecha: string;
  medio: boolean;
}

export function unirChat(escritos: EscritoPorTelefono[], recibidos: RecibidoPorTelefono[]): BurbujaChat[] {
  const burbujas: BurbujaChat[] = [
    ...escritos.map((e) => ({ id: e.id, lado: 'escrito' as const, texto: e.texto, fecha: e.fecha, medio: false })),
    ...recibidos.map((r) => ({
      id: r.id,
      lado: 'recibido' as const,
      texto: r.contenido,
      fecha: r.createdAt,
      medio: r.tipo === 'medio',
    })),
  ];
  // A igual hora, lo escrito va primero: la respuesta nunca precede a la pregunta.
  return burbujas.sort((a, b) => {
    const t = new Date(a.fecha).getTime() - new Date(b.fecha).getTime();
    if (t !== 0) return t;
    return a.lado === b.lado ? 0 : a.lado === 'escrito' ? -1 : 1;
  });
}

/** El panel corre en el ambiente de prueba solo con `vite --mode pruebas`. */
export function esAmbientePruebas(mode: string | undefined): boolean {
  return mode === 'pruebas';
}
